import { stationsApi } from '../api/station/station.api';
import { locationsApi } from '../api/locations/locations.api';
import { IStation, IStationResponse } from '../api/station/types';
import { store } from '../store/store';

export const POLLING_INTERVAL_MS = 60_000;

type AppDispatch = typeof store.dispatch;

export function seedStationsCache(dispatch: AppDispatch, stations: IStation[]): void {
    stations.forEach(station => {
        dispatch(
            stationsApi.util.upsertQueryData('getStationById', station._id, {
                data: station,
            } as IStationResponse)
        );
    });
}

export function upsertStationInCaches(
    dispatch: AppDispatch,
    locationId: string,
    stationId: string,
    response: IStationResponse
): void {
    dispatch(stationsApi.util.upsertQueryData('getStationById', stationId, response));
    dispatch(
        locationsApi.util.updateQueryData('getLocationById', locationId, draft => {
            if (!draft?.data?.stations) return;
            const idx = draft.data.stations.findIndex(s => s._id === stationId);
            if (idx >= 0) {
                draft.data.stations[idx] = response.data;
            }
        })
    );
}
